/**
 * @generated SignedSource<<2b79d10208a823441d1d7ab38f5c6a03>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdpUsersGroupingQuery$variables = {
  first?: number | null | undefined;
};
export type IdpUsersGroupingQuery$data = {
  readonly samlProviders: ReadonlyArray<{
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly idpNamespace: string;
    readonly name: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"IdpUsersGrouping_query">;
};
export type IdpUsersGroupingQuery = {
  response: IdpUsersGroupingQuery$data;
  variables: IdpUsersGroupingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpNamespace",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SAMLProvider",
  "kind": "LinkedField",
  "name": "samlProviders",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    (v4/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IdpUsersGroupingQuery",
    "selections": [
      {
        "args": (v1/*:: as any*/),
        "kind": "FragmentSpread",
        "name": "IdpUsersGrouping_query"
      },
      (v5/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "IdpUsersGroupingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CloudOrganizationConnection",
        "kind": "LinkedField",
        "name": "cloudOrganizations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CloudOrganizationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CloudOrganization",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provider",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "filters": null,
        "handle": "connection",
        "key": "IdpUsersGrouping_cloudOrganizations",
        "kind": "LinkedHandle",
        "name": "cloudOrganizations"
      },
      (v5/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "cc72bfe5ad524af25b2ecff46e92b296",
    "id": null,
    "metadata": {},
    "name": "IdpUsersGroupingQuery",
    "operationKind": "query",
    "text": "query IdpUsersGroupingQuery(\n  $first: Int\n) {\n  ...IdpUsersGrouping_query_3ASum4\n  samlProviders {\n    displayName\n    id\n    idpNamespace\n    name\n  }\n}\n\nfragment IdpUsersGrouping_query_3ASum4 on Query {\n  cloudOrganizations(first: $first) {\n    edges {\n      node {\n        id\n        name\n        provider\n        key\n        idpNamespace\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db4868b477a8e63d62585f825825ff84";

export default node;
